import { Col, Row } from "react-bootstrap";
import { BsCheckCircle } from "react-icons/bs";

const BulletCard = ({ colSpec, bullets, title, titleDescription, subTitle, footer, className }) => {
  return (
    <Col lg={colSpec} className={className}>
      <div className="content_box">
        {title && <h3>{title}</h3>}
        {titleDescription && <p className="instructions_text">{titleDescription}</p>}
        {subTitle && <h3 className="instructions_subtitle">{subTitle}</h3>}
        <div className="vspace_30"></div>
        <div className="content_info_bullet_list">
          {bullets.map(bullet => (
            <Row className="bullet" key={bullet.id}>
              <Col xs={1}>
                <BsCheckCircle color="#ADD500" />
              </Col>
              <Col>
                <h5>{bullet.title}</h5>
                <h6>{bullet.text}</h6>
              </Col>
            </Row>
          ))}
        </div>
        {footer && (
          <div className="content_box_footer">
            <p>
              {footer.map((part, index) =>
                typeof part === "string" ? (
                  <span key={index}>{part}</span>
                ) : (
                  <a key={index} target="_blank" rel="noreferrer noopener" href={part.linkUrl}>
                    {part.linkText}
                  </a>
                )
              )}
            </p>
          </div>
        )}
      </div>
    </Col>
  );
};

BulletCard.defaultProps = {
  colSpec: "",
  bullets: [],
  className: ""
};

export default BulletCard;
